"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StudentPersonalDetails = void 0;
var typeorm_1 = require("typeorm");
var student_personal_details_js_1 = require("../enums/student_personal_details.js");
var Users_js_1 = require("./Users.js");
var StudentPersonalDetails = /** @class */function () {
  function StudentPersonalDetails() {}
  __decorate([(0, typeorm_1.PrimaryGeneratedColumn)("uuid"), __metadata("design:type", String)], StudentPersonalDetails.prototype, "id", void 0);
  __decorate([(0, typeorm_1.OneToOne)(function (type) {
    return Users_js_1.Users;
  }), (0, typeorm_1.JoinColumn)(), __metadata("design:type", String)], StudentPersonalDetails.prototype, "user", void 0);
  __decorate([(0, typeorm_1.Column)({
    length: 10,
    nullable: true
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "whatsappNumber", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", Number)], StudentPersonalDetails.prototype, "graduationYear", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", Number)], StudentPersonalDetails.prototype, "postGraduationYear", void 0);
  __decorate([(0, typeorm_1.Column)({
    default: 0,
    type: "decimal"
  }), __metadata("design:type", Number)], StudentPersonalDetails.prototype, "class10Percentage", void 0);
  __decorate([(0, typeorm_1.Column)({
    default: 0,
    type: "decimal"
  }), __metadata("design:type", Number)], StudentPersonalDetails.prototype, "class12Percentage", void 0);
  __decorate([(0, typeorm_1.Column)({
    default: 0,
    type: "decimal"
  }), __metadata("design:type", Number)], StudentPersonalDetails.prototype, "graduationPercentage", void 0);
  __decorate([(0, typeorm_1.Column)({
    default: 0,
    type: "decimal",
    nullable: true
  }), __metadata("design:type", Number)], StudentPersonalDetails.prototype, "postGraduationPercentage", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "collegeName", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    type: "enum",
    enum: student_personal_details_js_1.collegeDegreeOptions
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "collegeDegree", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "pgCollegeName", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    type: "enum",
    enum: student_personal_details_js_1.collegeDegreeOptions
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "pgCollegeDegree", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    type: "enum",
    enum: student_personal_details_js_1.collegeDepartmentOptions
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "collegeDepartment", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    type: "enum",
    enum: student_personal_details_js_1.collegeDepartmentOptions
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "pgCollegeDepartment", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    type: "enum",
    enum: student_personal_details_js_1.jobStatusOptions
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "jobStatus", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    type: "int"
  }), __metadata("design:type", Number)], StudentPersonalDetails.prototype, "workExperienceMonths", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    type: "enum",
    enum: student_personal_details_js_1.jobTypeOptions
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "jobType", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    type: "decimal"
  }), __metadata("design:type", Number)], StudentPersonalDetails.prototype, "currentCtc", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "parentsContact", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    type: "enum",
    enum: student_personal_details_js_1.homeStateOptions
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "homeState", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "resume", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "discordId", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    type: "enum",
    enum: student_personal_details_js_1.enrollmentMethodOptions
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "enrollmentMethod", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "githubProfileLink", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    type: "decimal"
  }), __metadata("design:type", Number)], StudentPersonalDetails.prototype, "minSalaryGuarantee", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    type: "enum",
    enum: student_personal_details_js_1.placementStatusOptions
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "placementStatus", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "placementCompany", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    type: "decimal"
  }), __metadata("design:type", Number)], StudentPersonalDetails.prototype, "placementCtc", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", Date)], StudentPersonalDetails.prototype, "placementMonth", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", Date)], StudentPersonalDetails.prototype, "placementJoiningMonth", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "placementNotes", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    type: "enum",
    enum: student_personal_details_js_1.paymentStatusOptions
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "paymentStatus", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", Date)], StudentPersonalDetails.prototype, "paymentUpdatedAt", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    type: "enum",
    enum: student_personal_details_js_1.paymentTypeOptions
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "paymentType", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "paymentMode", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "githubToken", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "githubUsername", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "currentCompany", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "noticePeriod", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    type: "enum",
    enum: student_personal_details_js_1.genderOptions
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "gender", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    type: "enum",
    enum: student_personal_details_js_1.precoursePerformanceTagOptions
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "precoursePerformanceTag", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    type: "enum",
    enum: student_personal_details_js_1.otherCodingSkillsOptions,
    array: true,
    default: []
  }), __metadata("design:type", Array)], StudentPersonalDetails.prototype, "otherCodingSkills", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "currentState", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "currentCity", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    type: "enum",
    enum: student_personal_details_js_1.preferredCodingLanguageOptions
  }), __metadata("design:type", String)], StudentPersonalDetails.prototype, "preferredCodingLanguage", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    type: "int"
  }), __metadata("design:type", Number)], StudentPersonalDetails.prototype, "collegeBacklogs", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", Date)], StudentPersonalDetails.prototype, "dateOfBirth", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    type: "enum",
    array: true,
    enum: student_personal_details_js_1.preferredSpeakingLanguageOptions,
    default: []
  }), __metadata("design:type", Array)], StudentPersonalDetails.prototype, "preferredSpeakingLanguage", void 0);
  __decorate([(0, typeorm_1.CreateDateColumn)(), __metadata("design:type", Date)], StudentPersonalDetails.prototype, "created_at", void 0);
  __decorate([(0, typeorm_1.UpdateDateColumn)(), __metadata("design:type", Date)], StudentPersonalDetails.prototype, "updated_at", void 0);
  StudentPersonalDetails = __decorate([(0, typeorm_1.Entity)()], StudentPersonalDetails);
  return StudentPersonalDetails;
}();
exports.StudentPersonalDetails = StudentPersonalDetails;